import io from 'socket.io-client';
var socket = io(process.env.WS_URL);
export default socket;


//////////////////
// WEBPACK FOOTER
// ./plugins/socket.io.js
// module id = ./plugins/socket.io.js
// module chunks = 0 1 2 3 4